import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TableList, Typography } from 'seagull';
import VendorNameLink from '../components/VendorNameLink/VendorNameLink';
import ViewInvoice from '../components/ViewInvoice/ViewInvoice';
import { RequiresApproval } from './types';
const FutureInvoiceRow = (param)=>{
    let { testId, futureInvoice } = param;
    const displayedAgreementName = futureInvoice.displayedAgreementName();
    const items = [
        {
            value: /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx(VendorNameLink, {
                        testId: "".concat(testId, "-company-name"),
                        vendorName: futureInvoice.companyName(),
                        relationshipID: futureInvoice.relationshipId()
                    }),
                    displayedAgreementName && /*#__PURE__*/ _jsx(Typography, {
                        skin: "secondary",
                        testId: "".concat(testId, "-agreement-name"),
                        ellipsis: true,
                        children: displayedAgreementName
                    })
                ]
            })
        },
        {
            value: /*#__PURE__*/ _jsx(Typography, {
                testId: "".concat(testId, "-issue-date"),
                children: futureInvoice.issueDate()
            })
        },
        {
            value: /*#__PURE__*/ _jsx(Typography, {
                testId: "".concat(testId, "-due-date"),
                children: futureInvoice.dueDate()
            })
        },
        {
            value: /*#__PURE__*/ _jsx(Typography, {
                testId: "".concat(testId, "-requires-approval"),
                children: futureInvoice.requiresApproval() ? RequiresApproval.Yes : RequiresApproval.No
            })
        },
        {
            value: /*#__PURE__*/ _jsx(Typography, {
                testId: "".concat(testId, "-total"),
                children: futureInvoice.total()
            })
        },
        {
            value: /*#__PURE__*/ _jsx(ViewInvoice, {
                relationshipID: futureInvoice.relationshipId(),
                date: futureInvoice.rawIssueDate(),
                testId: "".concat(testId, "-view-invoice")
            })
        }
    ];
    return /*#__PURE__*/ _jsx(TableList.Row, {
        testId: testId,
        items: items
    });
};
export default FutureInvoiceRow;
